import { render, staticRenderFns } from "./BlocoCertificacaoTerritorio.vue?vue&type=template&id=15806cd1&lang=pug"
import script from "./BlocoCertificacaoTerritorio.vue?vue&type=script&lang=js"
export * from "./BlocoCertificacaoTerritorio.vue?vue&type=script&lang=js"
import style0 from "./BlocoCertificacaoTerritorio.vue?vue&type=style&index=0&id=15806cd1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports